<template>
  <section>
    <h4>CALENDAR</h4>
    <strong class="text-primary" v-if="currentBusinessContact">
    Creating a meeting with: {{inviteeName}}
    <br>
    </strong>
    The meeting will be created at the following times:   <strong>{{calendar.timezonelabel }}</strong>
    <div v-if="responder" class="alert alert-warning text-left p-2 my-2">
      <div>
        {{ $t('lang.calendar.invitee_last_response') }}: <strong>{{ responder.email }}</strong>
        (<span class="text-capitalize">{{ responderStatusLabel }}</span>, {{ responderDateLabel }})
        · {{ $t('lang.calendar.invitee_opportunity_contact') }}: <strong>{{ currentBusinessContact.email }}</strong>
      </div>
      <div v-if="canPreselectResponder" class="mt-2">
        <button v-if="useResponder" type="button" class="btn btn-sm btn-outline-primary" @click="useResponder = false">
          {{ $t('lang.calendar.invitee_use_original', { email: currentBusinessContact.email }) }}
        </button>
        <button v-else type="button" class="btn btn-sm btn-outline-primary" @click="useResponder = true">
          {{ $t('lang.calendar.invitee_use_responder', { email: responder.email }) }}
        </button>
      </div>
      <div class="form-check mt-2" v-if="otherGuestEmail">
        <input type="checkbox" class="form-check-input" id="inviteeAddOtherGuest" v-model="addOtherGuest">
        <label class="form-check-label" for="inviteeAddOtherGuest">
          {{ $t('lang.calendar.invitee_add_guest', { email: otherGuestEmail }) }}
        </label>
      </div>
      <div v-if="useResponder && currentBusinessContact.phone" class="mt-2 small">
        {{ $t('lang.calendar.invitee_original_phone') }}: {{ currentBusinessContact.phone }}
      </div>
    </div>
    <div v-if="creatingEvent" class="card shadow p-4 mt-4 text-center" style="min-height: 601px;">
          <div class="row mt-3">
            <div class="col-12">
              <h4 class="text-secondary">{{$t('lang.calendar.waitplease')}}...</h4>
              <img src="@/assets/images/creatingevent.gif"/>
            </div>
          </div>
      </div>
    <div class="col-2" v-if="openform && !creatingEvent">
							<button @click="back()" class="btn btn-primary float-left"><i class="icon-arrow-left mr-2"></i>{{ $t('lang.button.back') }}</button>
    </div>
    <div v-if="!creatingEvent">
      <div class="text-secondary pt-2 " v-if="dayselected.length == 0">
              <i class="icon-arrow-left cursor-pointer
              rounded-circle bg-primary text-white p-2 mr-2"
              @click="nextMonth(currentmonth-1,true)"
              v-if="!loading && fixedyear < theyear || (fixedyear == theyear && fixedmonth < currentmonth )"></i>
              <span>{{$t('lang.label.' + monthlabel )}} {{theyear}}</span>
              <i v-if="!loading" class="cursor-pointer icon-arrow-right ml-2
              rounded-circle text-white bg-primary p-2"
              @click="nextMonth(currentmonth+1,true)"></i>
              <span class="loadingres spinner-border loading-spinner ml-2" v-if="loading"></span>
              </div>
    <Calendar
      @createEvent="createEvent($event)"
      :class="loading ? 'blur' : ''"
      @showday="showDay($event)"
      @open="openForm"
      @timezone="selectTimeZone($event)"
      :timezones="timezones"
      @eventcreated="eventCreated($event)"
      @nextMonth="nextMonth(currentmonth + 1, false)"
      :key="calkey"
      :calendar="calendar"
      :businessName="businessName"
      :currentBusinessContact="newcurrentBusinessContact"
      :responder="responder"
      :useResponder="useResponder"
      :addOtherGuest="addOtherGuest"
      :monthlabel="monthlabel"
      :bc_hash = "bcHash"
      :isUserBdr="isUserBdr()"
    />
    </div>
   
  </section>
</template>
    
    <script>
import { mapState, mapActions } from "vuex";
import { myCalendarService  } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Calendar from "@/components/Calendar/NewCalendar.vue";
import Pagination from "@/components/Common/Pagination.vue";
import i18n from '@/_helpers/i18n';
import moment from "moment";

const MAX_EMPTY_MONTHS_TO_SKIP = 24;

export default {
  props: {
    user_id:null,
    link_hash:null,
    currentBusinessContact: null,
    lastHumanResponse: null,
    businessName: null
  },
  watch: {
    currentBusinessContact() {
      this.newcurrentBusinessContact = { ...this.currentBusinessContact }
      this.resetInviteeChoice()
    },
    lastHumanResponse() {
      this.resetInviteeChoice()
    }
  },
  data() {
    return {
      newcurrentBusinessContact: false,
      useResponder: false,
      addOtherGuest: false,
      business_contact_hash: false,
      campaign_hash: false,
      urlInvalid: false,
      timezone: 160,
      creatingEvent: false,
      newevent: false,
      account_id:'',
      dayselected: [],
      timezones: [],
      bcHash:"",
      daylabel: false,
      openform: false,
      loadingfirst: true,
      name: String,
      avatar: String,
      calendar: Object,
      currentmonth: 1,
      fixedmonth: 1,
      languages:[],
      monthlabel: "",
      calkey: 12232,
      hashash: false,
      loading: false,
      theyear: 1,
      fixedyear: 1,
      emptyMonthsSkipped: 0,
      calendarSearchCancelled: false,
      calendar: {
        title: "30 Minute Meeting",
        duration: "30 min",
        currentmonth: "",
        labelmonth: "",
        labeldays: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"],
        days: [],
        hours: [],
        name: "",
        accountId: false,
        currentmonth: false,
        currentyear: false,
        defaultTimezone: 160,
        timezonelabel: "Europe/Paris",
      },
      calendarDefault: {
        availability: [
          0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
          1, 1, 1, 1, 1, 2, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        ],
        avatar: null,
        name: "",
        calendar_description: "",
        duration_minutes: "",
        interval_minutes: 0,
      },
    };
  },
  components: {
    LoadingSpinner,
    Calendar,
  },

  created() {
    
    this.newcurrentBusinessContact = this.currentBusinessContact
    this.resetInviteeChoice()
    this.loading = true;
    this.$store.dispatch("optionsList/getProfileCountries").then(() => {
      this.countryNames = this.Countries.map(el => el.name);
      // const countryField = this.schemaStatus.fields.find(
      //   (field) => field.model === "country"
      // );
      // if (countryField) {
      //   countryField.values = [...this.countryNames]; // Asigna el Array actualizado
      // }
      this.countries = this.Countries;
    });
    let d = new Date();
    this.currentmonth = d.getMonth()+1
    this.fixedmonth = this.currentmonth
    this.theyear = d.getFullYear()
    this.fixedyear = this.theyear
    let month = ["january","frebruary","march","april","may","june","july","august","september","october","november","december"];
    this.monthlabel = month[this.currentmonth-1]
    
    this.bcHash = this.link_hash

    this.account_id = btoa(this.user_id)

    this.calendar.accountId = this.account_id;

    this.$store.dispatch("optionsList/getLanguages").then(() => {
      this.languages = this.Languages;
    });

    this.$store.dispatch("optionsList/getTimezones").then(() => {
      this.timezones = this.TimeZone;
      let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

      if (!this.isUserBdr()) {
        if (tz !== undefined && this.calendar.timezone === undefined) {
          let dataZone = tz.split("/");

          setTimeout(() => {
            if (this.completeLoadingCalendar) {
              this.timezones.forEach((item) => {
                if (item.label.includes(dataZone[1])) {
                  this.timezone = item.id;
                  this.calendar.timezone = item.id;
                  this.selectTimeZone(this.timezone);
                }
              });
            }
          }, 4000);
        }
      } else {
        this.selectTimeZone(this.timezone);
      }
    });
  },
  beforeDestroy() {
    this.calendarSearchCancelled = true;
  },
	computed: {
		...mapState({
			headerTab: state => state.header.tab,
			isMenuCollapse: state => state.sidebar.isNavOpen,
	    completeLoadingCalendar: (state) => state.optionsList.completeLoadingCalendar,
      currentUser: (state) => state.authentication.user,
      Languages: (state) => state.optionsList.all["languages"].data,
      Countries: (state) => state.optionsList.all["profile_countries"].data,
      TimeZone: (state) => state.optionsList.all["timezones"].data,
		}),
    responder() {
      const response = this.lastHumanResponse;
      const contact = this.currentBusinessContact;
      if (!response || !response.email || !contact) {
        return null;
      }
      if (this.normalizeEmail(response.email) === this.normalizeEmail(contact.email)) {
        return null;
      }
      return { ...response, same_person: this.isSamePerson(response.email, contact) };
    },
    canPreselectResponder() {
      return !!this.responder && [2, 10].includes(Number(this.responder.status_id));
    },
    otherGuestEmail() {
      if (!this.responder) {
        return "";
      }
      return this.useResponder ? this.currentBusinessContact.email || "" : this.responder.email;
    },
    responderStatusLabel() {
      return this.responder && this.responder.status_name ? this.responder.status_name.replace(/-/g, " ") : "";
    },
    responderDateLabel() {
      return this.responder && this.responder.date ? moment(this.responder.date).format("DD/MM") : "";
    },
    inviteeName() {
      const contact = this.currentBusinessContact;
      if (!this.useResponder || !this.responder) {
        return contact.name;
      }
      const responderName = this.responder.name || [this.responder.first_name, this.responder.last_name].filter(Boolean).join(" ");
      if (responderName) {
        return responderName;
      }
      return this.responder.same_person ? contact.name : this.responder.email;
    },
	},
  methods: {
    normalizeEmail(email) {
      return String(email || "").trim().toLowerCase();
    },
    normalizeNamePart(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .replace(/[^a-z]/g, "");
    },
    isSamePerson(email, contact) {
      const localPart = this.normalizeNamePart(String(email).split("@")[0]);
      const nameParts = [contact.first_name, contact.last_name, ...String(contact.name || "").split(/\s+/)]
        .map((part) => this.normalizeNamePart(part))
        .filter((part) => part.length >= 3);
      return nameParts.some((part) => localPart.includes(part));
    },
    resetInviteeChoice() {
      this.useResponder = this.canPreselectResponder;
      this.addOtherGuest = false;
    },
    ...mapActions("header", {
		changeHeaderTab: "changeTab"
		}),
		...mapActions("headertopbar", {
			setCurrentRoute:"setRoute",
			setCurrentRouteChild:"setRouteChild",
		}),
	    ...mapActions("optionsList", {
			getCalendarParam: "getCalendarParam",
	    }),
	    createEvent(data){
	    	this.creatingEvent = true
		    myCalendarService.createEventInCalendar(data).then((res) => {
          console.log("created-event"+res)
          if(res !=''){
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              text: "The event was created successfully",
              showConfirmButton: false,
              timer: 1500,
            });
          }
     
          this.creatingEvent = false
        }).catch(() => {
          this.creatingEvent = false
          this.back()
          this.$swal({
            type: "error",
            text: this.$t("lang.calendar.booking_error"),
          });
        });

	    },
    showDay(day) {
      this.daylabel = day;
    },
    isUserBdr() {
      return (this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2)
    },
    selectTimeZone(timezone) {
      this.timezone = timezone;
      this.timezones.forEach((item, key) => {
        if (item.id == this.timezone) {
          this.calendar.timezonelabel = item.label;
          this.calendar.defaultTimezone = item.id;
          this.calendar.timezone = item.id;
          this.timezone = item.id;
          return false;
        }
      });
      this.nextMonth(this.currentmonth, false);
    },
    selectTimeZoneLabel(label) {
      this.calendar.timezonelabel = label;
      this.timezones.forEach((item, key) => {
        if (item.label.indexOf(this.calendar.timezonelabel) !== -1) {
          this.calendar.timezonelabel = item.label;
          this.calendar.defaultTimezone = item.id;
          this.timezone = item.id;
          return;
        }
      });
      this.nextMonth(this.currentmonth, false);
      return;
    },
    eventCreated(model) {
      this.newevent = model;
    },
    openForm(dayselected) {
      
      this.dayselected = dayselected;
      this.openform = true;
    },

    loadCalendar(res){
      
			this.calendar.days=[]
			this.avatar = res.avatar
			this.name = res.name
			this.calendar.name = res.name
			this.calendar.calendar_description = res.calendar_description
			this.calendar.duration = res.duration_minutes+' min'
			this.calendar.title = res.duration_minutes+' Minute Meeting'
			res.availability.forEach((item, key)=>{
				this.calendar.days.push(item)
			})

			if(this.calendar.days.length == res.availability.length){
				this.calkey++
				this.loading = false
			}

			if(res.language_id){
              this.languages.forEach(item=>{
			
              if(item.id == res.language_id){
                i18n.locale = item.lang_code;
              }
            })
      
			}
		},
    getAvailabilityByMonth(month,theyear,account_id){
   
      //console.log("GET MONTH "+month)
			this.loading = true
			this.calendar.currentmonth = month
      this.calendar.account_id = account_id
			this.calendar.currentyear = theyear
			myCalendarService.getAvailabilityByMonth(month,theyear,this.account_id,this.timezone).then((res) => {
				if (this.calendarSearchCancelled) {
					return
				}
				if(res){
					const hasSlots = Array.isArray(res.availability) && res.availability.some(item => item > 1)
					if (!hasSlots && this.emptyMonthsSkipped < MAX_EMPTY_MONTHS_TO_SKIP) {
						this.emptyMonthsSkipped++
						this.nextMonth(this.currentmonth + 1, false, true)
						return
					}

					this.loadCalendar(res)
					this.loading = false
					this.loadingfirst = false
				}else{
				}
			}).catch(() => {
				this.loading = false
				this.loadingfirst = false
			})
		},
    back(){
			this.dayselected=[]
			this.openform=false
			this.calkey++
		},
    nextMonth(currentmonth, saveactivity, skippingEmptyMonths = false) {
      if (!skippingEmptyMonths) {
        this.emptyMonthsSkipped = 0;
      }
      if (currentmonth == 13) {
        currentmonth = 1;
        this.theyear++;
      }
      if (currentmonth == 0) {
        currentmonth = 12;
        this.theyear--;
      }
      this.currentmonth = currentmonth;
      let month = [
        "january",
        "frebruary",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december",
      ];
      this.monthlabel = month[currentmonth - 1];
      this.getAvailabilityByMonth(currentmonth, this.theyear, this.account_id);

      if (
        saveactivity &&
        typeof this.business_contact_hash !== "undefined" &&
        typeof this.campaign_hash !== "undefined"
      ) {
        myCalendarService.insertActivity(
          this.campaign_hash,
          this.business_contact_hash,
          true,
          "Next Month: " + this.theyear + "/" + currentmonth
        );
      }
    },
  },
};
</script>
